module.exports = __webpack_public_path__ + "static/media/RP-80.1b0aa5e7.pdf";